import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            精彩分类
          </h2>
          <p className="text-sm text-foreground-500">探索你感兴趣的内容领域</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-background-200 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-secondary-100 text-secondary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400">
                  {cat.videoCount}个视频
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}